/* eslint-disable */
<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { ADMIN_TAX_APPROVAL } from '@/store/types';
import taxesApi from '@/services/apis/admin/tax.api';

export default {
  props: {
    page: {
      type: Number,
      default: 1,
    },
    per_page: {
      type: Number,
      default: 10,
    },
    keyword: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    employer_id: {
      type: String,
      default: null,
    },
    start_date: {
      type: String,
      default: null,
    },
    end_date: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const store = useStore();
    const query = ref(null);
    query.value = taxesApi.useAdminInvoicesQuery({
      page: props.page,
      per_page: props.per_page,
      keyword: props.keyword,
      employer_id: props.employer_id,
      start_date: props.start_date,
      end_date: props.end_date,
      status: props.status,
    });
    if (query.value) {
      store.commit(ADMIN_TAX_APPROVAL.SET_TAX_APPROVAL, query);
    }
    return { query };
  },
};
</script>
